import {pushGA4} from './dataLayerPush';

const getPageNameGA4 = () => 'booking::step4payment';

export const pushFunnelStepInfo = () => {
  pushGA4({
    event: 'GA4event',
    eventName: 'funnel_step',
    event_data: {
      pagename: getPageNameGA4(),
      step_name: 'step4',
    }
  }, 'event_data')
}

export const pushEcommerceInfo = (data) => {
  if (data) {
    pushGA4({
      event: data.event,
      ecommerce: data.ecommerce,
    }, 'ecommerce')
  }
}

export const pushPaymentSubmitAction = (blockName = 'bottom') => {
  pushGA4({
    event: 'GA4event',
    eventName: 'payment_submit',
    event_data: {
      pagename: getPageNameGA4(),
      bloc_name: blockName,
    }
  }, 'event_data')
}

export const pushPaymentSubmitErrorAction = (data) => {
  if (data) {
    pushGA4({
      event: 'GA4event',
      eventName: 'payment_interact',
      event_data: {
        pagename: getPageNameGA4(),
        form_action: 'error form',
        ...data
      }
    }, 'event_data')
  }
}

export const pushBasketInteractAction = (ctaName) => {
  if (ctaName) {
    pushGA4({
      event: 'GA4event',
      eventName: 'basket_information',
      event_data: {
        pagename: getPageNameGA4(),
        cta_name: ctaName,
      }
    }, 'event_data')
  }
}
